import { render, staticRenderFns } from "./EditExamProcess.vue?vue&type=template&id=ff6caace&scoped=true"
import script from "./EditExamProcess.vue?vue&type=script&lang=js"
export * from "./EditExamProcess.vue?vue&type=script&lang=js"
import style0 from "./EditExamProcess.vue?vue&type=style&index=0&id=ff6caace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6caace",
  null
  
)

export default component.exports